/* LumevaGlow interactions: reveal, sticky header, countdown, popup, upsell */
(function () {
  var DAY = 24 * 60 * 60 * 1000;

  function reveal(scope) {
    var root = scope || document;
    var targets = root.querySelectorAll("[data-lg-reveal]");
    if (!("IntersectionObserver" in window)) {
      targets.forEach(function (el) {
        el.classList.add("lg-in");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("lg-in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );
    targets.forEach(function (el, i) {
      if (el.classList.contains("lg-in")) return;
      el.classList.add("lg-reveal");
      el.style.transitionDelay = Math.min(i * 70, 280) + "ms";
      io.observe(el);
    });
  }

  function sticky() {
    var onScroll = function () {
      document.body.classList.toggle("lg-sticky", window.scrollY > 12);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  function deadline() {
    var key = "lg-sale-deadline";
    var stored = parseInt(window.localStorage.getItem(key) || "0", 10);
    if (!stored || isNaN(stored) || stored <= Date.now()) {
      stored = Date.now() + DAY;
      try {
        window.localStorage.setItem(key, String(stored));
      } catch (e) {}
    }
    return stored;
  }

  function clocks() {
    var nodes = document.querySelectorAll("[data-lg-clock]");
    if (!nodes.length) return;
    var end = deadline();
    var pad = function (n) {
      return n < 10 ? "0" + n : String(n);
    };
    var tick = function () {
      var left = end - Date.now();
      if (left <= 0) {
        try {
          window.localStorage.removeItem("lg-sale-deadline");
        } catch (e) {}
        end = deadline();
        left = end - Date.now();
      }
      var h = Math.floor(left / 3600000);
      var m = Math.floor((left % 3600000) / 60000);
      var s = Math.floor((left % 60000) / 1000);
      nodes.forEach(function (node) {
        var hh = node.querySelector("[data-h]");
        var mm = node.querySelector("[data-m]");
        var ss = node.querySelector("[data-s]");
        if (hh) hh.textContent = pad(h);
        if (mm) mm.textContent = pad(m);
        if (ss) ss.textContent = pad(s);
      });
    };
    tick();
    window.clearInterval(window.__lgClock);
    window.__lgClock = window.setInterval(tick, 1000);
  }

  function popup() {
    var pop = document.querySelector("[data-lg-pop]");
    if (!pop || pop.dataset.lgBound === "1") return;
    pop.dataset.lgBound = "1";
    var seen = false;
    try {
      seen = window.sessionStorage.getItem("lg-pop-seen") === "1";
    } catch (e) {}
    var close = function () {
      pop.classList.remove("lg-pop--open");
      try {
        window.sessionStorage.setItem("lg-pop-seen", "1");
      } catch (e) {}
    };
    pop.querySelectorAll("[data-lg-pop-close]").forEach(function (btn) {
      btn.addEventListener("click", close);
    });
    pop.addEventListener("click", function (e) {
      if (e.target === pop) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && pop.classList.contains("lg-pop--open")) close();
    });
    var copyBtn = pop.querySelector("[data-lg-copy]");
    if (copyBtn) {
      copyBtn.addEventListener("click", function () {
        var code = copyBtn.getAttribute("data-lg-copy") || "";
        var done = function () {
          var label = copyBtn.textContent;
          copyBtn.textContent = "Copied";
          window.setTimeout(function () {
            copyBtn.textContent = label;
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          done();
        }
      });
    }
    if (!seen) {
      window.setTimeout(function () {
        pop.classList.add("lg-pop--open");
      }, 6000);
    }
  }

  function protection() {
    var box = document.querySelector("[data-lg-protect]");
    if (!box || box.dataset.lgBound === "1") return;
    box.dataset.lgBound = "1";
    var input = box.querySelector('input[type="checkbox"]');
    if (!input) return;
    input.addEventListener("change", function () {
      var variant = box.getAttribute("data-variant-id");
      var lineKey = box.getAttribute("data-line-key");
      input.disabled = true;
      var request;
      if (input.checked) {
        request = fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] }),
        });
      } else if (lineKey) {
        request = fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: lineKey, quantity: 0 }),
        });
      }
      if (!request) {
        input.disabled = false;
        return;
      }
      request
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          input.disabled = false;
        });
    });
  }

  function atcUrgency() {
    if (!document.body.classList.contains("lg-product")) return;
    if (document.querySelector(".lg-pd .lg-atc")) return;
    var tpl = document.querySelector("[data-lg-atc-template]");
    if (!tpl) return;
    var anchor =
      document.querySelector("add-to-cart-component") ||
      document.querySelector(".product-form__buttons") ||
      document.querySelector('button[name="add"]');
    if (!anchor) return;
    var host = anchor.closest("add-to-cart-component") || anchor.parentElement;
    if (!host || host.parentElement.querySelector(".lg-atc")) return;
    var node = tpl.content ? tpl.content.cloneNode(true) : null;
    if (!node) return;
    host.parentElement.insertBefore(node, host.nextSibling);
  }


  function reviewSliders() {
    document.querySelectorAll("[data-lg-rv]").forEach(function (root) {
      if (root.dataset.lgRvReady) return;
      root.dataset.lgRvReady = "1";
      var track = root.querySelector("[data-lg-rv-track]");
      if (!track) return;
      var step = function () {
        var card = track.querySelector(".lg-rv__card");
        return card ? card.offsetWidth + 18 : track.clientWidth * 0.8;
      };
      var prev = root.querySelector("[data-lg-rv-prev]");
      var next = root.querySelector("[data-lg-rv-next]");
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });

      var paused = false;
      ["pointerenter", "focusin", "touchstart"].forEach(function (e) {
        root.addEventListener(e, function () { paused = true; }, { passive: true });
      });
      ["pointerleave", "focusout"].forEach(function (e) {
        root.addEventListener(e, function () { paused = false; });
      });
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      setInterval(function () {
        if (paused) return;
        var max = track.scrollWidth - track.clientWidth - 4;
        if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: "smooth" });
        else track.scrollBy({ left: step(), behavior: "smooth" });
      }, 4200);
    });
  }

  function init() {
    reveal();
    clocks();
    popup();
    protection();
    atcUrgency();
    reviewSliders();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
      sticky();
    });
  } else {
    init();
    sticky();
  }
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("cart:update", protection);
})();
